export default __webpack_public_path__ + "static/media/alert-circle-outline.2afd351d.svg";